import _ from "lodash";
import React, { Fragment, useState, useMemo } from "react";
import classes from "./SupervisorComment.scss";
import { useI18n } from "Hooks";
import { TextAreaInput, useDSContext } from "@toddle-edu/ds-web";
import classNames from "classnames";

const SupervisorComment = ({
  assessmentRemarks,
  headingLabel = null,
  subheadingLabel = null,
  updateRemarks,
  disabled = false,
  inputRef,
  testId = "appComponent",
}) => {
  const { t } = useI18n(["project", "common"]);
  const { dsVersion } = useDSContext();
  const isDSV2 = dsVersion === "2.0";

  const [supervisorComment, setSupervisorComment] = useState(
    assessmentRemarks?.message ?? ""
  );

  const subheadingClass = classNames({
    "text-body-2": !isDSV2,
    [classes.subheadingLabel]: !isDSV2,
    "text-body": isDSV2,
    [classes.subheadingLabelV2]: isDSV2,
  });

  const onChangeDebounce = useMemo(
    () =>
      _.debounce(value => {
        updateRemarks({ supervisorComment: value });
      }, 300),
    []
  );

  const onChange = e => {
    setSupervisorComment(e.target.value);
    onChangeDebounce(e.target.value);
  };

  return (
    <Fragment>
      <div
        className={
          isDSV2
            ? classes.headingLabelContainerV2
            : classes.headingLabelContainer
        }
      >
        <h6 className={isDSV2 ? "text-heading-6" : "heading-5"}>
          {headingLabel ? headingLabel : t("project:supervisor_s_comment")}
        </h6>
        {subheadingLabel ? (
          <div className={subheadingClass}>{subheadingLabel}</div>
        ) : null}
      </div>
      <TextAreaInput
        ref={inputRef}
        name={"remarks"}
        value={supervisorComment}
        onChange={onChange}
        //onBlur={() => updateRemarks({ supervisorComment })}
        placeholder={t("common:typeHere")}
        disabled={disabled}
        testId={`${testId}-supervisorComment`}
      />
    </Fragment>
  );
};

export default SupervisorComment;
